function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Triangles",
    xmlns: "http://www.w3.org/2000/svg",
    width: 743,
    height: 973,
    viewBox: "0 0 743 973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_120891",
    "data-name": "\\uD328\\uC2A4 120891",
    d: "M371.5,0,743,866H0Z",
    transform: "translate(743 866) rotate(180)",
    fill: "#404040",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M371.5,0,743,866H0Z",
    transform: "translate(0 107)",
    fill: "#404040",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTriangle);
export default __webpack_public_path__ + "static/media/bigTriangle.866c9ab22bb7028b332e894c582a7fa3.svg";
export { ForwardRef as ReactComponent };